(ns teamoesterreich.admin-mode.data.lebensretter
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]

            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn >send-welcome-mail [tom-id done-fn failed-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/i-lebensretter/toe/" tom-id "/send-welcome-mail")
                  (fn [result status]
                    (log/debug ">send-welcome-mail done" result status)
                    (if (= status 200)
                      (done-fn)
                      (failed-fn)
                      ))))

(defn >send-push-message [tom-id message done-fn failed-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/i-lebensretter/toe/" tom-id "/send-push-message")
                   (ajax/serialize {:message message})
                   (fn [result status]
                     (log/debug ">send-push-message done" result status)
                     (if (= status 200)
                       (done-fn)
                       (failed-fn)
                       ))))

(defn <sync-receiver [tom-id done-fn & [failed-fn]]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/i-lebensretter/toe/" tom-id "/sync-receiver")
                   (fn [result status]
                     (log/debug "<sync-receiver done" result status)
                     (if (= status 200)
                       (done-fn)
                       (failed-fn)
                       ))))

